import { memo } from 'react';

import { Button, Flex } from 'antd';

import AppModal from '../../components/AppModal';

function UnsavedChangesModal({ isOpen, handleCancel, handleDiscard, handleConfirm }) {
  return (
    <AppModal
      confirmButtonColor="danger"
      confirmButtonText="Discard"
      title="You have unsaved changes"
      isOpen={isOpen}
      handleCancel={handleCancel}
      footer={<Footer handleCancel={handleCancel} handleConfirm={handleConfirm} handleDiscard={handleDiscard} />}>
      <div className="py-4">
        If you leave now, your changes will be lost. Would you like to save, discard, or continue editing?
      </div>
    </AppModal>
  );
}

function Footer({ handleCancel, handleConfirm, handleDiscard }) {
  return (
    <Flex gap="small" justify="space-between" key="actions">
      <Button size="large" variant="solid" color="danger" onClick={handleDiscard}>
        Discard
      </Button>

      <Flex gap="small">
        <Button size="large" onClick={handleCancel}>
          Cancel
        </Button>
        <Button size="large" type="primary" onClick={handleConfirm}>
          Save
        </Button>
      </Flex>
    </Flex>
  );
}

export default memo(UnsavedChangesModal);
